import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <section
  tabindex="-1"
  id={{this.elementId}}
  aria-hidden={{not this.isVisible}}
  class={{this.HTMLClassList}}
  {{did-insert this.registerAppEventListeners}}
  {{will-destroy this.deregisterAppEventListeners}}
>
  {{#if this.isVisible}}
    <div
      aria-hidden="false"
      tabindex="0"
      role="document"
      class="d-lightbox__content"
      style={{this.CSSVars}}
      aria-labelledby={{this.titleElementId}}
      {{on "keydown" this.onKeydown passive=false capture=true}}
      {{on "keyup" this.onKeyup passive=true capture=true}}
    >
      <div class="d-lightbox__focus-trap" tabindex="0"></div>
      <DLightbox::Header
        @canDownload={{this.canDownload}}
        @canFullscreen={{this.canFullscreen}}
        @canNavigate={{this.canNavigate}}
        @close={{this.close}}
        @openInNewTab={{this.openInNewTab}}
        @toggleCarousel={{this.toggleCarousel}}
        @toggleFullScreen={{this.toggleFullScreen}}
        @totalItemCount={{this.totalItemCount}}
        @counterIndex={{this.counterIndex}}
      />
      <DLightbox::Body
        @close={{this.close}}
        @centerZoomedBackgroundPosition={{this.centerZoomedBackgroundPosition}}
        @currentItem={{this.currentItem}}
        @hasLoadingError={{this.hasLoadingError}}
        @isLoading={{this.isLoading}}
        @isZoomed={{this.isZoomed}}
        @nextButtonIcon={{this.nextButtonIcon}}
        @onTouchend={{this.onTouchend}}
        @onTouchstart={{this.onTouchstart}}
        @previousButtonIcon={{this.previousButtonIcon}}
        @reloadImage={{this.reloadImage}}
        @shouldDisplayMainImageArrows={{this.shouldDisplayMainImageArrows}}
        @showNextItem={{this.showNextItem}}
        @showPreviousItem={{this.showPreviousItem}}
        @toggleZoom={{this.toggleZoom}}
        @zoomOnMouseover={{this.zoomOnMouseover}}
      />
      {{#if this.shouldDisplayCarousel}}
        <DLightbox::Carousel
          @currentIndex={{this.currentIndex}}
          @items={{this.items}}
          @nextButtonIcon={{this.nextButtonIcon}}
          @previousButtonIcon={{this.previousButtonIcon}}
          @showNextItem={{this.showNextItem}}
          @showPreviousItem={{this.showPreviousItem}}
          @showSelectedImage={{this.showSelectedImage}}
          @shouldDisplayCarouselArrows={{this.shouldDisplayCarouselArrows}}
        />
      {{/if}}
      <DLightbox::Footer
        @canDownload={{this.canDownload}}
        @canRotate={{this.canRotate}}
        @canZoom={{this.canZoom}}
        @currentItem={{this.currentItem}}
        @downloadImage={{this.downloadImage}}
        @rotateImage={{this.rotateImage}}
        @shouldDisplayTitle={{this.shouldDisplayTitle}}
        @toggleExpandTitle={{this.toggleExpandTitle}}
        @toggleZoom={{this.toggleZoom}}
        @zoomButtonIcon={{this.zoomButtonIcon}}
      />

      <DLightbox::ScreenReaderAnnouncer
        @currentItem={{this.currentItem}}
        @counterIndex={{this.counterIndex}}
        @totalItemCount={{this.totalItemCount}}
        @titleElementId={{this.titleElementId}}
      />
      <div class="d-lightbox__focus-trap" tabindex="0"></div>
    </div>
  {{/if}}
</section>
*/
{
  "id": "2ipLCSNn",
  "block": "[[[11,\"section\"],[24,\"tabindex\",\"-1\"],[16,1,[30,0,[\"elementId\"]]],[16,\"aria-hidden\",[28,[37,0],[[30,0,[\"isVisible\"]]],null]],[16,0,[30,0,[\"HTMLClassList\"]]],[4,[38,1],[[30,0,[\"registerAppEventListeners\"]]],null],[4,[38,2],[[30,0,[\"deregisterAppEventListeners\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"isVisible\"]],[[[1,\"    \"],[11,0],[24,\"aria-hidden\",\"false\"],[24,\"tabindex\",\"0\"],[24,\"role\",\"document\"],[24,0,\"d-lightbox__content\"],[16,5,[30,0,[\"CSSVars\"]]],[16,\"aria-labelledby\",[30,0,[\"titleElementId\"]]],[4,[38,4],[\"keydown\",[30,0,[\"onKeydown\"]]],[[\"passive\",\"capture\"],[false,true]]],[4,[38,4],[\"keyup\",[30,0,[\"onKeyup\"]]],[[\"passive\",\"capture\"],[true,true]]],[12],[1,\"\\n      \"],[10,0],[14,0,\"d-lightbox__focus-trap\"],[14,\"tabindex\",\"0\"],[12],[13],[1,\"\\n      \"],[8,[39,5],null,[[\"@canDownload\",\"@canFullscreen\",\"@canNavigate\",\"@close\",\"@openInNewTab\",\"@toggleCarousel\",\"@toggleFullScreen\",\"@totalItemCount\",\"@counterIndex\"],[[30,0,[\"canDownload\"]],[30,0,[\"canFullscreen\"]],[30,0,[\"canNavigate\"]],[30,0,[\"close\"]],[30,0,[\"openInNewTab\"]],[30,0,[\"toggleCarousel\"]],[30,0,[\"toggleFullScreen\"]],[30,0,[\"totalItemCount\"]],[30,0,[\"counterIndex\"]]]],null],[1,\"\\n      \"],[8,[39,6],null,[[\"@close\",\"@centerZoomedBackgroundPosition\",\"@currentItem\",\"@hasLoadingError\",\"@isLoading\",\"@isZoomed\",\"@nextButtonIcon\",\"@onTouchend\",\"@onTouchstart\",\"@previousButtonIcon\",\"@reloadImage\",\"@shouldDisplayMainImageArrows\",\"@showNextItem\",\"@showPreviousItem\",\"@toggleZoom\",\"@zoomOnMouseover\"],[[30,0,[\"close\"]],[30,0,[\"centerZoomedBackgroundPosition\"]],[30,0,[\"currentItem\"]],[30,0,[\"hasLoadingError\"]],[30,0,[\"isLoading\"]],[30,0,[\"isZoomed\"]],[30,0,[\"nextButtonIcon\"]],[30,0,[\"onTouchend\"]],[30,0,[\"onTouchstart\"]],[30,0,[\"previousButtonIcon\"]],[30,0,[\"reloadImage\"]],[30,0,[\"shouldDisplayMainImageArrows\"]],[30,0,[\"showNextItem\"]],[30,0,[\"showPreviousItem\"]],[30,0,[\"toggleZoom\"]],[30,0,[\"zoomOnMouseover\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"shouldDisplayCarousel\"]],[[[1,\"        \"],[8,[39,7],null,[[\"@currentIndex\",\"@items\",\"@nextButtonIcon\",\"@previousButtonIcon\",\"@showNextItem\",\"@showPreviousItem\",\"@showSelectedImage\",\"@shouldDisplayCarouselArrows\"],[[30,0,[\"currentIndex\"]],[30,0,[\"items\"]],[30,0,[\"nextButtonIcon\"]],[30,0,[\"previousButtonIcon\"]],[30,0,[\"showNextItem\"]],[30,0,[\"showPreviousItem\"]],[30,0,[\"showSelectedImage\"]],[30,0,[\"shouldDisplayCarouselArrows\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[8,[39,8],null,[[\"@canDownload\",\"@canRotate\",\"@canZoom\",\"@currentItem\",\"@downloadImage\",\"@rotateImage\",\"@shouldDisplayTitle\",\"@toggleExpandTitle\",\"@toggleZoom\",\"@zoomButtonIcon\"],[[30,0,[\"canDownload\"]],[30,0,[\"canRotate\"]],[30,0,[\"canZoom\"]],[30,0,[\"currentItem\"]],[30,0,[\"downloadImage\"]],[30,0,[\"rotateImage\"]],[30,0,[\"shouldDisplayTitle\"]],[30,0,[\"toggleExpandTitle\"]],[30,0,[\"toggleZoom\"]],[30,0,[\"zoomButtonIcon\"]]]],null],[1,\"\\n\\n      \"],[8,[39,9],null,[[\"@currentItem\",\"@counterIndex\",\"@totalItemCount\",\"@titleElementId\"],[[30,0,[\"currentItem\"]],[30,0,[\"counterIndex\"]],[30,0,[\"totalItemCount\"]],[30,0,[\"titleElementId\"]]]],null],[1,\"\\n      \"],[10,0],[14,0,\"d-lightbox__focus-trap\"],[14,\"tabindex\",\"0\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[],false,[\"not\",\"did-insert\",\"will-destroy\",\"if\",\"on\",\"d-lightbox/header\",\"d-lightbox/body\",\"d-lightbox/carousel\",\"d-lightbox/footer\",\"d-lightbox/screen-reader-announcer\"]]",
  "moduleName": "discourse/components/d-lightbox.hbs",
  "isStrictMode": false
});